import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../login/login.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: LoginService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const isLoggedIn = this.authService.isLoggedIn();
    const isRootPath = state.url === '/' || state.url === '';
    if (isLoggedIn) {
      if (state.url === '/' || state.url === '/login') {
        return this.router.createUrlTree(['/home']);
      }
      return true;
    }

    // If not logged in, allow access to /login
    if (isRootPath || state.url === '/login') {
      return true;
    }

    // Redirect to auth message component url with returnUrl for any other path
    return this.router.createUrlTree(['/auth-message'], {
      queryParams: { returnUrl: state.url }
    });
  }

}
